import { render } from "./DashboardAllotmentComponent.vue?vue&type=template&id=df8b294c&scoped=true"
import script from "./DashboardAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./DashboardAllotmentComponent.vue?vue&type=script&lang=js"

import "./DashboardAllotmentComponent.vue?vue&type=style&index=0&id=df8b294c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df8b294c"]])

export default __exports__